import React from 'react'
import { items } from '../../constants/items'
import { DesktopLg, Tablet, TabletLand } from '../../constants/screenWidth'
import Medical from '../../images/medical2.png'


class ProductsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: "",
      items: [],
      category: "",
      searchInput: "",
      displaySearch:"",
      displayModal: false,
      currentItem: ""
    }
  }

  componentDidUpdate() {
    window.addEventListener('resize', this.updateShowcaseRow)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateShowcaseRow)
  }

  componentDidMount() {
    this.updateShowcaseRow()
  }

  toggleModal = item => {
    if (this.state.displayModal) {
      this.setState({
        displayModal: false,
      })
    } else {
      this.setState({
        displayModal: true,
        currentItem: item
      })
    }
  }

  closeModal = () => {
    this.setState({
      displayModal: false
    })
  }

  setFilter = e => {
    console.log(e)
    this.setState({
      filter: e
    }, () => {
      this.updateShowcaseRow()
    })
  }

  updateSearch = e => {
    this.setState({
      searchInput: e.target.value
    })
  }

  updateShowcaseRow = () => {
    const { filter } = this.state
    let itemsPerRow = 4
    let tempColumnItems = []
    let tempArray = []

    if (window.innerWidth < Tablet) {
      itemsPerRow = 1
    } else if (window.innerWidth < TabletLand) {
      itemsPerRow = 2
    } else if (window.innerWidth < DesktopLg) {
      itemsPerRow = 3
    }

    console.log(items)
    console.log(filter)

    const itemCategory = filter ? items.filter(item => (item.category === filter)) : items

    console.log(itemCategory)

    itemCategory.forEach((item, index) => {
      item.empty = false
      tempArray.push(item)
      if (tempArray.length === itemsPerRow) {
        tempColumnItems.push(tempArray)
        tempArray = []
      }
    })

    while (tempArray.length < itemsPerRow) {
      tempArray.push({empty: true})
    }

    tempColumnItems.push(tempArray)

    this.setState({
      items: tempColumnItems
    })
  }

  render() {
    const { currentItem, items,  displayModal} = this.state

    return (
      <React.Fragment>
        <div className={`modal-escape ${displayModal ? '' : 'hidden'}`} onClick={this.toggleModal} />     
        <div className={`modal-wrapper ${displayModal ? '' : 'hidden'}`}>
          <div className="modal-container">
            <img src={currentItem.src}/>
            <div className="modal-description">
              <h1>{currentItem.name}</h1>
              <h2>Lead Time:</h2>
              <a>{currentItem.leadTime}</a>
              <h2>Quantity:</h2>
              <a>{currentItem.perbox}</a>
              <h2>Description</h2>
              <a>{currentItem.description}</a>
              <h2/>
            </div>
          </div>
        </div>
        <div className="products-page-container">
          <a className="title">Products</a>
          <div className="coverimage">
            <img src={Medical} />
          </div>
          <div className="categories">
            <a className="types" onClick={() => this.setFilter("")}> 
              All 
              <div className="button-underline" />
            </a>
            <a className="types" onClick={() => this.setFilter("Masks")}> 
              Masks 
              <div className="button-underline" />
            </a>
            <a className="types" onClick={() => this.setFilter("Hand Sanitizers")}> 
              Hand Sanitizers
              <div className="button-underline" />
            </a>
            <a className="types" onClick={() => this.setFilter("Thermometers")}> 
              Thermometers
              <div className="button-underline" />
            </a>
            <a className="types" onClick={() => this.setFilter("Gowns/Coveralls")}> 
              Gowns/Coveralls 
              <div className="button-underline" />
            </a>
          </div>
          {
            items.map((row, cIndex) => {
              return(
                <div key={`row-${cIndex}`} className="item-image-row">
                  {
                    row.map((item, index) => {
                      return(
                        <div className="item-container" > 
                          <div key={`row-${cIndex} item-${index}`} className="item-image-container" onClick={() => this.toggleModal(item)}>
                            {
                              !item.empty && <img src={item.src}/>
                            }
                          </div>
                          {
                            !item.empty && 
                              <div className="item-description">
                                <a>{item.name}</a>
                                {/* <span>{item.category}</span> */}
                                <div className="item-learn-more" onClick={() => this.toggleModal(item)}>
                                  Learn more
                                </div>
                              </div>
                          }
                        </div>
                      )
                    })
                  }
                </div>
              )
            })
          }
        </div>
      </React.Fragment>
    )
  }
}

export default ProductsPage